import { keepPreviousData, queryOptions, useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { qk } from "@/lib/query-keys";
import { toastErrorApi, toastExito } from "@/lib/toast";
import {
  listarEventosFallidos,
  reprocesarEventoFallido,
  resumirEventosFallidos,
  type ListarEventosFallidosParams,
} from "../services/eventos-fallidos-service";

/** Hotspot 55 · conteo de eventos con error por módulo (todos los outbox). */
export const resumenEventosFallidosQueryOptions = queryOptions({
  queryKey: [...qk.adminEventosFallidos, "modulos"] as const,
  queryFn: resumirEventosFallidos,
});

export const eventosFallidosQueryOptions = (params: ListarEventosFallidosParams) =>
  queryOptions({
    queryKey: [...qk.adminEventosFallidos, "lista", params] as const,
    queryFn: () => listarEventosFallidos(params),
    placeholderData: keepPreviousData,
    enabled: params.modulo.length > 0,
  });

export function useResumenEventosFallidos() {
  return useQuery(resumenEventosFallidosQueryOptions);
}

export function useEventosFallidos(params: ListarEventosFallidosParams) {
  return useQuery(eventosFallidosQueryOptions(params));
}

export function useReprocesarEventoFallido() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ modulo, id }: { modulo: string; id: string }) => reprocesarEventoFallido(modulo, id),
    onSuccess: () =>
      toastExito({
        title: "Evento reencolado",
        message: "Se volverá a procesar en el siguiente ciclo del despachador (segundos).",
      }),
    onError: toastErrorApi,
    onSettled: () => qc.invalidateQueries({ queryKey: qk.adminEventosFallidos }),
  });
}
